import type {Post} from './posts';
import type {Channel} from './channels';
import type {UserProfile} from './users';

export enum UserThreadType {
    Synthetic = 'S' // derived from post
}

export type UserThread = {
    id: string;
    reply_count: number;
    last_reply_at: number;
    last_viewed_at: number;
    participants: Array<{id: UserProfile['id']} | UserProfile>;
    unread_replies: number;
    unread_mentions: number;
    type?: UserThreadType;

    // TODO consider flattening, removing post from UserThreads in-store
    /**
     * only depend on channel_id and user_id for UserThread<>Channel/User mapping,
     * use normalized post store/selectors as those are kept up-to-date in the store
     */
    post: {
        channel_id: Channel['id'];
        user_id: UserProfile['id'];
    };
};

type SyntheticMissingKeys = 'unread_replies' | 'unread_mentions';
export type UserThreadSynthetic = Omit<UserThread, SyntheticMissingKeys> & {
    type: UserThreadType.Synthetic;
    is_following: boolean | null;
}

export function threadIsSynthetic(thread: UserThread | UserThreadSynthetic): thread is UserThreadSynthetic {
    return thread.type === UserThreadType.Synthetic;
}

export type UserThreadWithPost = UserThread & {post: Post};

export type UserThreadList = {
    total: number;
    total_unread_threads: number;
    total_unread_mentions: number;
    threads: UserThreadWithPost[];
}
